import React, { useEffect, useState } from 'react'
import FoundationsSelect from '../../GenericComponents/select'
import { title } from 'process'
import ReactSelectDropdown, { ReactSelect_LightMode, ReactSelect_DarkMode } from '../../Components/ReactSelect'
import { FoundationsOptionType } from '../../Types/FoundationsTypes'
import { getCurrentUserData, RootState } from '../../Redux/store'
import { FoundationsConstants } from '../../FoundationsConstants'
import { useSelector } from 'react-redux'
interface DataTableProps {
    columns: string[]
    Mapper: any
    ParentFields: { [key: string]: any }[]
    FilterValues: { [key: string]: any }
    AddRow?: () => void
    FiltersUpdated: (DropdownValues: { [key: string]: any }) => void
}

const DataMapperFilters: React.FC<DataTableProps> = ({
    columns,
    Mapper,
    ParentFields,
    FilterValues,
    AddRow,
    FiltersUpdated,
}) => {
    const [isParent, setIsParent] = useState<{ [key: string]: boolean }>({})
    const [selectedValues, setSelectedValues] = useState<{ [key: string]: any }>({})
    const [LoadFilters, setLoadFilters] = useState(false)
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))

    useEffect(() => {
        if (Object.keys(selectedValues).length === 0) {
            const initialSelectedValues = columns.reduce(
                (acc, column) => {
                    acc[column] = AddRow ? '' : (FilterValues[column] || '');
                    return acc
                },
                {} as { [key: string]: any }
            )

            setSelectedValues(initialSelectedValues)
            setLoadFilters(true)
        }
        if (!AddRow) {
            setIsParent(
                columns.reduce(
                    (acc, column) => {
                        acc[column] = ParentFields.some((field) =>
                            Object.values(field).includes(column)
                        )
                        return acc
                    },
                    {} as { [key: string]: boolean }
                )
            )
        }
    }, [columns, ParentFields, FilterValues, AddRow])

    
    const DropdownValueSelected = (result: { [key: string]: any }) => {
        setLoadFilters(false)
        // Fix: Remove any numeric keys like '0', '1'
        const extractedResult: { [key: string]: any } = {}

        Object.entries(result).forEach(([key, val]) => {
            // Only keep string keys and extract `.value` if needed
            if (isNaN(Number(key))) {
                extractedResult[key] = val?.value ?? val
            }
        })
        const updatedSelectedValues = { ...selectedValues, ...result }
        setSelectedValues(updatedSelectedValues)
        FiltersUpdated(updatedSelectedValues)
        setLoadFilters(true)
    }

    if (columns.length === 0) {
        return null   // No need to render anything
    }

    if (LoadFilters) {
        return (
        <tr id="dataFilters">
            {AddRow &&
            <th></th>}
            {columns.map((column) => {
                const optionsForColumn: FoundationsOptionType[] = [
                    {
                        value: '',
                        label: `-Select a ${column}-`,
                        title: `-Select a ${column}-`,
                    },
                    ...(Mapper.Value[column] || []).map((item: { value: string }) => ({
                        value: item.value,
                        label: item.value,
                        title: item.value,
                    })),
                ];
                return (!AddRow && isParent[column])?(
                    <th>*</th>
                ):(
                <th id={`${column}_parent`}>
                 {/* <FoundationsSelect
                    options={[
                        { value: "", 
                         label: `-Select a ${column}-`,
                         title:`-Select a ${column}-`//FP-10620
                         },
                        ...(Mapper.Value[column] || []).map((item: { value: string; }) => ({
                            value: item.value,
                            label: item.value,
                            title: item.value,//FP-10620                            
                        }))
                    ]}
                    value={selectedValues[column]}
                    onChange={DropdownValueSelected}
                    placeHolder={`-Select a ${column}-`}
                    isSearchable={true}
                    id={`${column}`}
                    classes="foundation-select-black-background" //FP-10417
                /> */}
                <ReactSelectDropdown 
                    options={optionsForColumn}
                    onChange={(selectedOption: any) => {
                        DropdownValueSelected({ [column]: selectedOption?.value ?? '' });
                    }}
                    // onChange = {DropdownValueSelected} 
                    id={''} 
                    // styleProps={currentUserData.DisplayMode === FoundationsConstants.DisplayMode.Night ? ReactSelect_DarkMode : ReactSelect_LightMode} 
                    styleProps={currentUserData.DisplayMode === FoundationsConstants.DisplayMode.Night ? ReactSelect_DarkMode : ReactSelect_LightMode}
                    isClearable={false} 
                    menuPlacement={'auto'} 
                    placeholder={`-Select a ${column}-`}
                    value = {selectedValues[column] ? [optionsForColumn.find(option => option.value === selectedValues[column])].filter(Boolean) : undefined}

                />
                </th>
            )})}
            {AddRow &&
            <th>
                <button className="app-button mb-1" onClick={AddRow}>Add Row</button>
            </th>}
        </tr>
        )
    }
}

export default DataMapperFilters
